import React from 'react'
import FooterInfoLayout from '@layouts/footer-info-layout'

import AutobacsLogo from '@images/footer-info/Autobacs-Logo.png'
import CheersLogo from '@images/footer-info/Cheers-Logo.png'
import ColdStorageLogo from '@images/footer-info/Cold-Storage-logo.png'

import FairPriceLogo from '@images/footer-info/FairPrice-Logo.png'
import GiantLogo from '@images/footer-info/Giant-logo.png'
import HardwareCityLogo from '@images/footer-info/HardwareCity-Logo.png'
import OGPlatLogo from '@images/footer-info/OG-Logo.png'
import SelffixLogo from '@images/footer-info/Selffix-Logo.png'
import ShellSelectLogo from '@images/footer-info/Shell-Select-Logo.jpg'
import ShopeeLogo from '@images/footer-info/Shopee-logo.png'
import YuehwaLogo from '@images/footer-info/Yue-hwa-logo.png'
import HouzeLogo from '@images/footer-info/houze-logo.png'
import LazadaLogo from '@images/footer-info/lazada-logo.png'
import TheWonderShopLogo from '@images/footer-info/the-wonder-shop-logo.png'
import WatsonsLogo from '@images/footer-info/watsons-logo.png'
import GuardianLogo from '@images/footer-info/guardian-logo.png'
import { Grid, GridItem, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'

const ITEMS = {
  autobacslogo: {
    image: AutobacsLogo,
    link: '#',
    width: 0,
    height: 0
  },
  cheerslogo: {
    image: CheersLogo,
    link: '#',
    width: 0,
    height: 0
  },
  coldstoragelogo: {
    image: ColdStorageLogo,
    link: '#',
    width: 0,
    height: 0
  },
  fairpricelogo: {
    image: FairPriceLogo,
    link: 'https://www.fairprice.com.sg/category/jml-singapore-pte-ltd',
    width: 0,
    height: 0
  },
  giantlogo: {
    image: GiantLogo,
    link: '#',
    width: 280,
    height: 0
  },
  hardwarecitylogo: {
    image: HardwareCityLogo,
    link: '#',
    width: 0,
    height: 0
  },
  ogplatlogo: {
    image: OGPlatLogo,
    link: '#',
    width: 245,
    height: 240
  },
  selffixlogo: {
    image: SelffixLogo,
    link: '#',
    width: 0,
    height: 0
  },
  shellselectlogo: {
    image: ShellSelectLogo,
    link: '#',
    width: 250,
    height: 0
  },
  shopeelogo: {
    image: ShopeeLogo,
    link: 'https://shopee.sg/jml.sg',
    width: 0,
    height: 0
  },
  yuehwalogo: {
    image: YuehwaLogo,
    link: '#',
    width: 0,
    height: 0
  },
  houzelogo: {
    image: HouzeLogo,
    link: '#',
    width: 224,
    height: 100
  },
  lazadalogo: {
    image: LazadaLogo,
    link: 'https://www.lazada.sg/shop/jml/?path=promotion-38576-0.htm&tab=promotion',
    width: 0,
    height: 0
  },
  thewondershoplogo: {
    image: TheWonderShopLogo,
    link: 'https://wondershop.sg/',
    width: 0,
    height: 0
  },
  watsonslogo: {
    image: WatsonsLogo,
    link: 'https://www.watsons.com.sg/search?text=jml',
    width: 0,
    height: 0
  },
  guardianlogo: {
    image: GuardianLogo,
    link: 'https://guardian.com.sg/brands/jml.html',
    width: 0,
    height: 0
  }
}

const PartnersList = ({
  title,
  items
}: {
  title: string
  items: { image: any; link: string; width: number; height: number }[]
}) => {
  return (
    <VStack w={'100%'}>
      <Text textStyle={'tcTitleLarge'} w={'100%'}>
        {title}
      </Text>
      <Grid
        templateColumns={{ sm: 'repeat(2, 6fr)', lg: 'repeat(3, 4fr)' }}
        gap={16}
        alignItems={'center'}
        w={'100%'}
      >
        {items.map((item, k) => {
          const logo = (
            <Image
              src={item.image}
              alt="logo"
              width={item.width}
              height={item.height}
              // style={{
              //   width: '100%'
              // }}
            ></Image>
          )
          const hasLink = item.link && item.link !== '#'
          return (
            <GridItem key={k} margin={'auto'}>
              {hasLink ? (
                <Link href={item.link} target="_blank">
                  {logo}
                </Link>
              ) : (
                logo
              )}
            </GridItem>
          )
        })}
      </Grid>
    </VStack>
  )
}

const Partners = () => {
  const online = [
    ITEMS.shopeelogo,
    ITEMS.lazadalogo,
    ITEMS.guardianlogo,
    ITEMS.fairpricelogo,
    ITEMS.thewondershoplogo,
    ITEMS.watsonslogo
  ]

  const offline = [
    ITEMS.fairpricelogo,
    ITEMS.giantlogo,
    ITEMS.coldstoragelogo,
    ITEMS.yuehwalogo,
    ITEMS.ogplatlogo,
    ITEMS.selffixlogo,
    ITEMS.watsonslogo,
    ITEMS.cheerslogo,
    { ...ITEMS.guardianlogo, link: '#' }
    // ITEMS.autobacslogo,
    // ITEMS.hardwarecitylogo,
    // ITEMS.shellselectlogo,
    // ITEMS.houzelogo
  ]

  return (
    <FooterInfoLayout title="Partners" vstack={{ spacing: 14 }}>
      <VStack gap={20} w={'100%'}>
        <PartnersList items={online} title="Online Platform" />
        <PartnersList items={offline} title="Offline Platform" />
      </VStack>
    </FooterInfoLayout>
  )
}

export default Partners
